// Wrapper for rendering markdown content, primarily meant for GKs and CMS MD content
import Markdown from 'react-markdown';

export type MarkdownWrapperProps = {
  content: string;
};
export const Md = (props: MarkdownWrapperProps) => {
  const { content } = props;

  return <Markdown>{content}</Markdown>;
};
